import React from 'react';
import { Navigate } from 'react-router-dom';
import constants from '../constants';

const PrivateRoute = ({ component: Component }) => {
  // Save the current path for redirect after login
  sessionStorage.setItem("redirect_to", window.location.pathname);
  
  // In React Router v6, we directly return components rather than using Route's render prop
  return sessionStorage.getItem(constants.GC_TOKEN) 
    ? <Component /> 
    : <Navigate to="/" replace />;
};

export default PrivateRoute;